import React from "react";

const HiringManagerCard = ({ image, name, title, url, colorSectionText }) => (
  <div
    style={{ color: colorSectionText }}
    className="flex space-x-2 md:space-x-4"
  >
    <div className="flex-shrink-0 w-16 h-16 rounded-full shadow-lg md:w-20 md:h-20">
      {url ? (
        <a href={`https://${url}`} target="_new">
          <img
            className="border-2 border-white border-solid rounded-full"
            src={image}
            alt={name}
          />
        </a>
      ) : (
        <img
          className="border-2 border-white border-solid rounded-full"
          src={image}
          alt={name}
        />
      )}
    </div>
    <div>
      {url ? (
        <a href={`https://${url}`} target="_new">
          <h5 className="text-sm font-medium xl:text-base">{name}</h5>
        </a>
      ) : (
        <h5 className="text-sm font-medium xl:text-base">{name}</h5>
      )}
      <p className="text-sm xl:text-base">{title}</p>
    </div>
  </div>
);

export default HiringManagerCard;
